import React, { Component } from 'react';
const MapsTableRow = ({ color, visible, activity, time }) => {
  
    return (
      <tr className={color + " table-sm"} hidden={!visible}>
        <td>{activity}</td>
        <td>{time}</td>
      </tr>
    );
  };
  
  export default MapsTableRow;